import * as React from 'react';
import { useEffect, useContext } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Container,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StorageContext } from '../store/storageContext';
import StorageListMobile from './StorageListMobile';
import loadingStorages from './loadingStorages';
import DesktopList from '../utils/components/DesktopList';
import StorageForm from './StorageForm';
import StorageRow from './StorageRow';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    [theme.breakpoints.down('md')]: {
      fontSize: '2.5rem',
    },
  },
}));

const StorageList: React.FC = () => {
  const classes = useStyles();
  const {
    getStorages,
    storages,
    getStoragesLoading,
    addStorage,
    addStorageLoading,
  } = useContext(StorageContext);
  const theme = useTheme();
  const isMediumOrSmaller = useMediaQuery(theme.breakpoints.down('lg'));
  const { t } = useTranslation('nav');

  useEffect(() => {
    getStorages();
  }, [getStorages]);

  return (
    <Container maxWidth="lg">
      <Typography
        align="left"
        variant="h3"
        className={classes.title}
        sx={(theme) => ({
          ...theme.typography.listTitle,
          color: theme.palette.titleColor,
        })}
      >
        {t('t.storages')}
      </Typography>
      {isMediumOrSmaller ? (
        <StorageListMobile
          storages={getStoragesLoading ? loadingStorages : storages}
          loading={getStoragesLoading}
        />
      ) : (
        <DesktopList<StorageType, StorageFormDto>
          headers={['name', 'lastReportDate', 'lastInventoryDate', 'site']}
          data={getStoragesLoading ? loadingStorages : storages}
          loading={getStoragesLoading}
          ns="storages"
          add={addStorage}
          get={getStorages}
          emptyKey="noStorages"
          renderAddForm={({ onSubmit, buttonText }) => (
            <StorageForm
              loading={addStorageLoading}
              onSubmit={onSubmit}
              buttonText={buttonText}
            />
          )}
          renderBody={({ data, loading, columnCount }) => (
            <StorageRow
              key={data.id}
              storage={data}
              loading={loading}
              colCount={columnCount}
            />
          )}
          showAdd
        />
      )}
    </Container>
  );
};

export default StorageList;
